export interface Sorting {
  [index: number]: number;
}

export interface Address {
  name?: string;
  street: string;
  house_number: string;
  address_extra?: string;
  postal_code: string;
  city: string;
  country: string;
  neighbourhood?: string;
  coordinate?: Coordinate;
  radius?: number;
  isSpecific?: boolean;
  alternative?: Address[];
}

export const defaultAddress: Address = {
  street: '',
  house_number: '',
  postal_code: '',
  city: '',
  country: '',
};

export interface PartialAddress {
  name?: string;
  street?: string;
  house_number?: string;
  address_extra?: string;
  postal_code: string;
  city: string;
  country?: string;
  neighbourhood?: string;
  coordinate?: Coordinate;
}

export interface Coordinate {
  lat: number;
  lng: number;
}

export const isLocatable = (address: PartialAddress): boolean => {
  return !!address.postal_code && !!address.city;
};

export const hasCoordinate = (address: PartialAddress): boolean => {
  return !!address.coordinate;
};
